import { IconButton } from '@material-ui/core';
import {
  Add as AddIcon,
  Visibility as VisibilityIcon,
} from '@material-ui/icons';
import DoneIcon from '@material-ui/icons/Done';
import EditIcon from '@material-ui/icons/Edit';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { deleteStudentAchievement } from '@webapps/business';
import {
  Modal,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeadCell,
  TableHeadRow,
  TableRow,
  useMutation,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { getFileURLPDF } from '@webapps/utils';
import ModalFullScreenWithoutAction from 'components/ModalFullScreenWithoutAction/ModalFullScreenWithoutAction';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import AddAchievement from './AddAchievement';
import theme from './theme';

const {
  colors: { background },
} = theme;

const Achievement = ({ achievements = [], refetch }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const [addAchievement, setAddAchievement] = useState(false);
  const [viewAchievement, setViewAchievement] = useState(false);
  const [path, setPath] = useState('');

  const { addToast } = useToast();

  const handleOpenAddAchievement = () => {
    setAddAchievement(true);
  };
  const handleCloseAddAchievement = () => {
    setAddAchievement(false);
  };

  const handleOpenViewAchievement = (link, type) => {
    setPath('');
    getFileURLPDF(link, setPath);
    if (type === 'link') goToPath(link);
    else setViewAchievement(true);
  };
  const handleCloseViewAchievement = () => {
    setViewAchievement(false);
  };

  const [visibleDelete, setVisibleDelete] = useState(true);

  const handleDeleteVisible = () => {
    setVisibleDelete(!visibleDelete);
  };

  const {
    isLoading: isLoadingDelete,
    isSuccess: isSuccessDelete,
    mutateAsync: mutateDeleteAchievement,
  } = useMutation(deleteStudentAchievement);

  useEffect(() => {
    if (isSuccessDelete) {
      addToast({
        status: 'success',
        message: 'Opération réussie',
      });
      refetch();
    }
  }, [isSuccessDelete]);

  const deleteAchievement = async (id) => {
    await mutateDeleteAchievement({
      id,
    });
  };

  const goToPath = (url) => {
    // eslint-disable-next-line no-unused-expressions
    url.includes('http')
      ? window.open(url, '_blank', 'noopener,noreferrer')
      : window.open(`http://${url}`, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className={classes.container}>
      <div className={classes.editContainer}>
        <div className={global.title}>
          <FormattedMessage id="student.profil.realisation.title" /> {achievements.length ? '(' + achievements.length + ')' : ''}
        </div>
        <div style={{ display: 'flex' }}>
          <IconButton onClick={handleOpenAddAchievement} size="small" style={{ margin: 3, borderRadius: '20px', border: '1px solid #C0D9FF', backgroundColor: '#F3F7FF', width: '30px', display: 'flex', justifyContent: 'center', height: '30px', alignItems: 'center', cursor: 'pointer' }}>
            <AddIcon fontSize="small" style={{ color: '#5A6DA1' }} />
          </IconButton>
          {achievements.length > 0 && (
            <IconButton onClick={handleDeleteVisible} size="small" style={{ margin: 3, borderRadius: '20px', border: '1px solid #C0D9FF', backgroundColor: '#F3F7FF', width: '30px', display: 'flex', justifyContent: 'center', height: '30px', alignItems: 'center', cursor: 'pointer' }}>
              {visibleDelete ? (
                <EditIcon fontSize="inherit" style={{ color: '#5A6DA1' }} />
              ) : (
                <DoneIcon fontSize="inherit" style={{ color: '#5A6DA1' }} />
              )}
            </IconButton>
          )}
        </div>
      </div>
      {!achievements?.length ? (
        <div
          className={cx(css({
            textAlign: 'center',
            marginTop: spacing(2),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '190px',
          }), global.infoText)}
        >
          <FormattedMessage id="noElements" />
        </div>
      ) : (
        <TableContainer className={css({ marginBottom: spacing(3) })}>
          <Table>
            <TableHead>
              <TableHeadRow>
                <TableHeadCell style={{
                    padding: spacing(1, 0),
                    textTransform: 'none',
                  }}
                  className={global.infoText}
                >
                  <FormattedMessage id="student.profil.realisation.table.nom" />
                </TableHeadCell>
                <TableHeadCell style={{
                    padding: spacing(1, 0),
                    textTransform: 'none'
                  }}
                  className={global.infoText}
                >
                  <FormattedMessage id="student.profil.realisation.table.format" />
                </TableHeadCell>
              </TableHeadRow>
            </TableHead>
            <TableBody>
              {achievements?.map(({ id, label, path: pathFile, type }) => (
                <TableRow key={id}>
                  <TableCell style={{
                    padding: spacing(1, 0),
                     }}
                     className={global.infoText}
                  >{label}</TableCell>
                  <TableCell style={{
                    padding: spacing(1, 0),
                    }}
                    className={global.infoText}
                  >{type === 'link' ? 'Lien' : 'Fichier'}</TableCell>
                  <TableCell style={{
                    padding: spacing(1, 0),
                    }}
                    className={global.infoText}
                  >
                    <div className={css({position: 'relative'})}>
                      <IconButton size="small">
                        <VisibilityIcon
                          color="primary"
                          fontSize="small"
                          onClick={() =>
                            handleOpenViewAchievement(pathFile, type)
                          }
                        />
                      </IconButton>
                      <IconButton
                        className={css({
                          display: visibleDelete && 'none',
                          padding: 0, border: 'none',
                          position: 'absolute',
                          top: 1,
                        })}
                        disabled={isLoadingDelete}
                        onClick={() => deleteAchievement(id)}
                        size="small"
                      >
                        <HighlightOffIcon color="secondary" />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      <Modal
        onCancel={handleCloseAddAchievement}
        open={addAchievement}
        title={<FormattedMessage id="addAchievement" />}
      >
        <AddAchievement close={handleCloseAddAchievement} refetch={refetch} />
      </Modal>
      <ModalFullScreenWithoutAction
        onCancel={handleCloseViewAchievement}
        open={viewAchievement}
        title="Réalisations"
      >
        <iframe
          className={css({ width: '100%', height: '100%' })}
          frameBorder="0"
          src={path}
          title="Fichier"
        />
      </ModalFullScreenWithoutAction>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    background,
    flex: '1 1 0px',
    borderRadius: 10,
    padding: spacing(3),
    minHeight: 200,
    marginTop: spacing(3),
    height: '100%',
  },
  editContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
});

Achievement.propTypes = {
  achievements: PropTypes.array,
  refetch: PropTypes.func,
};

export default Achievement;
